// extracted by mini-css-extract-plugin
var _1 = "screen and (min-width: 1440px)";
var _2 = "screen and (min-width: 1600px)";
var _3 = "screen and (max-width: 767px)";
var _4 = "(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi), (min-resolution: 2dppx)";
var _5 = "screen and (min-width: 900px)";
var _6 = "screen and (min-width: 768px)";
var _7 = "-1";
var _8 = "1600";
var _9 = "1599";
var _a = "1440";
var _b = "767";
var _c = "0";
var _d = "1439";
var _e = "900";
var _f = "899";
var _10 = "768";
var _11 = "#000000";
var _12 = "#006192";
var _13 = "#007AB3";
var _14 = "#003781";
var _15 = "#2C3A47";
var _16 = "#90A4AE";
var _17 = "#93acc2";
var _18 = "#1F2D3B";
var _19 = "#202e3b";
var _1a = "#485561";
var _1b = "#283541";
var _1c = "#EFE0BA";
var _1d = "#CE9402";
var _1e = "#006192";
var _1f = "#007AB3";
var _20 = "#6AD8A5";
var _21 = "#485561";
var _22 = "#4CADDE";
var _23 = "#75B9D8";
var _24 = "#A2DEF9";
var _25 = "#388DB7";
var _26 = "#E57373";
var _27 = "#FFC124";
var _28 = "#6AD8A5";
var _29 = "#E57373";
var _2a = "#78909C";
var _2b = "#80B0C9";
var _2c = "#FFFFFF";
var _2d = "#ECEFF1";
var _2e = "#FFC124";
export { _1 as "breakpoints-desktop", _2 as "breakpoints-desktop-large", _3 as "breakpoints-phone", _4 as "breakpoints-retina", _5 as "breakpoints-tablet-landscape", _6 as "breakpoints-tablet-portrait", _7 as "breakpointsSizes-desktop-large-max", _8 as "breakpointsSizes-desktop-large-min", _9 as "breakpointsSizes-desktop-max", _a as "breakpointsSizes-desktop-min", _b as "breakpointsSizes-phone-max", _c as "breakpointsSizes-phone-min", _d as "breakpointsSizes-tablet-landscape-max", _e as "breakpointsSizes-tablet-landscape-min", _f as "breakpointsSizes-tablet-portrait-max", _10 as "breakpointsSizes-tablet-portrait-min", _11 as "palette-black", _12 as "palette-blue", _13 as "palette-blue-glare", _14 as "palette-blue-shade", _15 as "palette-charcoal", _16 as "palette-charcoal-glare", _17 as "palette-charcoal-glare-2", _18 as "palette-charcoal-shade", _19 as "palette-darkgray-shade-2", _1a as "palette-darkgrey", _1b as "palette-darkgrey-shade", _1c as "palette-graph-beige", _1d as "palette-graph-blonde", _1e as "palette-graph-blue", _1f as "palette-graph-glareblue", _20 as "palette-graph-green", _21 as "palette-graph-grid-color", _22 as "palette-graph-lightblue", _23 as "palette-graph-lightblue-1", _24 as "palette-graph-lightblue-2", _25 as "palette-graph-petrol", _26 as "palette-graph-red", _27 as "palette-graph-yellow", _28 as "palette-green", _29 as "palette-red", _2a as "palette-tidal", _2b as "palette-tidal-glare", _2c as "palette-white", _2d as "palette-white-shade", _2e as "palette-yellow" }
